<template>
    <b-row class="invoice-details">
        <b-col xl="6" md="6" sm="6">
            <b-table-simple borderless>
                <b-tbody>
                    <input
                        type="hidden"
                        name="invoice-id"
                        :value="invoice.id"
                    />
                    <b-tr class="row">
                        <b-th class="col-4">Client:</b-th>
                        <b-td class="col-8">
                            <span v-if="invoice.client">
                                <client-name
                                    :client="invoice.client"
                                    :text="invoice.client.display_name"
                                />
                            </span>
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Account Balance:</b-th>
                        <b-td class="col-8">
                            {{ _toCurrency(invoice.account_balance) }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Status:</b-th>
                        <b-td class="col-8">
                            {{
                                invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF
                                    ? "Written Off"
                                    : invoice.status_label
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Payment Terms:</b-th>
                        <b-td class="col-8">
                            {{ invoice.payment_term_label }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Created:</b-th>
                        <b-td class="col-8">
                            {{ _carbonDateDisplay(invoice.start) }}
                            <template v-if="invoice.estimates.length > 0">
                                (
                                <span
                                    v-for="(est, i) in invoice.estimates"
                                    :key="est.index"
                                >
                                    <estimate-link
                                        :estimate="est"
                                        :useRouter="USE_ESTIMATE_MODULE_VUE"
                                        :text="`Est #${est.index}`"
                                    />
                                    {{
                                        invoice.estimates.length != i + 1
                                            ? ", "
                                            : ""
                                    }} </span
                                >)
                            </template>
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Location:</b-th>
                        <b-td class="col-8" v-if="invoice.location_id">
                            <contact-name
                                v-if="invoice.location_is_contact"
                                :contact="invoice.location"
                                :type="invoice.location_type"
                                :text="invoice.location.label"
                            />
                            <client-name
                                v-else
                                :client="invoice.location"
                                :text="invoice.location.label"
                            />
                        </b-td>
                        <b-td class="col-8" v-else>
                            {{ invoice.location_name }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Notes: </b-th>
                        <b-td
                            class="col-8 note-spacing"
                            v-html="convertNewLineToBreak(invoice.note)"
                        >
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-col>

        <!-- 2nd column -->
        <b-col xl="6" md="6" sm="6">
            <InvoiceDisplayDetails />
        </b-col>
    </b-row>
</template>
<script>
/**
 * @name InvoiceDisplay
 * @see apps/application/views/staff/billing/invoice/invoice/view.php
 */

import InvoiceDisplayDetails from "@/components/invoice/invoice-display-details";
import EstimateLink from "@/components/commons/estimate-link";
import ClientName from "@/components/commons/client-name";
import ContactName from "@/components/commons/contact-name";
import ClientServices from "@/services/client";
import BILLINGS from "@/constants/billings";
export default {
    components: {
        ClientName,
        InvoiceDisplayDetails,
        EstimateLink,
        ContactName
    },
    props: {
        invoice: {
            type: Object
        }
    },
    data() {
        return {
            BILLINGS
        };
    },
    methods: {
        checkNegativeNumber(value) {
            return value < 0 ? `(${Math.abs(value)})` : value;
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.invoice-details th,
.invoice-details td {
    padding: 0px !important;
    line-height: 35px;
}
.invoice-details tr {
    padding-left: 1.5rem !important;
}

.note-spacing {
    line-height: normal !important;
}
</style>
